import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getChatbotAuthToken } from 'services/ChatBotService'
import { setChatbotTokenCookie } from 'utils/utils'

export const useChatBotQuery = () => {
  return useQuery(reactQueryKeys.chatbotToken(), () => getChatbotAuthToken(), {
    enabled: false,
    onError: error => logSentryError('Error: useChatBotQuery', error),
    select(data) {
      setChatbotTokenCookie(data?.token)
      return data?.token
    },
  })
}
